import Modal from "react-awesome-modal";
import { getListofFeaturesQuery } from "../../../../services/graphql/queries/roles";
import {withApollo} from "react-apollo"
import React from "react"

class ProductPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      moduleErrMsg: "",
      featureErrMsg: "",
      moduleValue: "",
      featureValue: "",
      listOfFeatures: []
    };
    this.cancelPopup = this.cancelPopup.bind(this);
    this.submitProductsubmitPrivilegePopUp = this.submitPrivilege.bind(this);
  }

  cancelPopup() {
    this.setState({
      moduleErrMsg: "",
      featureErrMsg: ""
    });
    this.props.onCloseModal();
  }

  submitPrivilege() {
    const { moduleValue, featureValue, listOfFeatures } = this.state;
    var isValid = true;
    if (moduleValue == "") {
      this.setState({
        moduleErrMsg: "*Select Module to proceed"
      });
      isValid = false;
    } else {
      this.setState({ moduleErrMsg: "" });
    }
    if (featureValue == "") {
      this.setState({
        featureErrMsg: "*Select a feature for this privilege"
      });
      isValid = false;
    } else {
      this.setState({ featureErrMsg: "" });
    }

    if (!isValid) {
      return;
    }
    this.props.onModuleAndFeaturesSelected(
      moduleValue,
      featureValue,
      listOfFeatures
    );
  }

  onChangeModule(e) {
    this.setState({
      moduleValue: e.target.value,
      featureValue: "",
      listOfFeatures: []
    });

    this.props.client
      .query({
        query: getListofFeaturesQuery,
        variables: {
          moduleId: parseInt(e.target.value.split(" ")[0])
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const listOfFeatures = result.data.getListofFeatures;

        this.initialState = {
          listOfFeatures: listOfFeatures
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  onChangeFeatures(e) {
    this.setState({
      featureValue: e.target.value
    });
  }
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps && nextProps.visible) {
  //     this.setState({ moduleValue: "", featureValue: "" });
  //   }
  // }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ moduleValue: "", featureValue: "" });
    }
  }

  render() {
    const { listOfFeatures, moduleValue, featureValue } = this.state;
    const { listOfModules } = this.props;

    return (
      <>
        <Modal
          visible={this.props.visible}
          className="m-w-900 popup-style-1"
          effect="fadeInDown"
          width="900"
        >
          <div className="modal-content modal-content-alignment">
            <div className="modal-header">
              <div className="row">
                <h1 className="heading m-l-28">Select Privilege</h1>
              </div>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 col-lg-5">
                  <div className="form-group">
                    <label>Module</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <select
                      className={
                        "form-control select-style-1 " +
                        (this.state.moduleErrMsg != "" ? "is-invalid" : "")
                      }
                      value={moduleValue}
                      onChange={e => {
                        this.onChangeModule(e);
                      }}
                    >
                      <option value={""}>Select</option>
                      {listOfModules.length
                        ? listOfModules.map((data, index) => {
                            return (
                              <option
                                key={index}
                                value={data.Id + " " + data.moduleName}
                              >
                                {data.moduleName}
                              </option>
                            );
                          })
                        : null}
                    </select>
                    <div class="invalid-feedback" style={{ display: "block" }}>
                      {this.state.moduleErrMsg}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-5">
                  <div className="form-group">
                    <label>Feature</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <select
                      className={
                        "form-control select-style-1 " +
                        (this.state.featureErrMsg != "" ? "is-invalid" : "")
                      }
                      value={featureValue}
                      onChange={e => {
                        this.onChangeFeatures(e);
                      }}
                    >
                      <option value={""}>Select</option>
                      {listOfFeatures.length
                        ? listOfFeatures.map((data, index) => {
                            return (
                              <option
                                key={index}
                                value={data.Id + " " + data.description}
                              >
                                {data.description}
                              </option>
                            );
                          })
                        : null}
                    </select>
                    <div class="invalid-feedback" style={{ display: "block" }}>
                      {" "}
                      {this.state.featureErrMsg}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light"
                onClick={e => {
                  this.cancelPopup();
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={e => {
                  this.submitPrivilege();
                }}
              >
                Select
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withApollo(ProductPopUp);
